module.exports = __webpack_public_path__ + "static/media/logo.abb9ab39.svg";